export enum PaperSize {
  A4 = 'A4',
  Letter = 'Letter',
}

export enum Orientation {
  Portrait = 'portrait',
  Landscape = 'landscape',
}

export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;
export const LETTER_WIDTH_MM = 215.9;
export const LETTER_HEIGHT_MM = 279.4;

export interface IDocumentSettings {
  fontFamily?: string;
  fontSize?: string;
  lineHeight?: string;
  paragraphSpacing?: string;
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  paperSize?: PaperSize;
  orientation?: Orientation;
}

export const SYSTEM_DOCUMENT_DEFAULTS: Readonly<Required<IDocumentSettings>> = {
  fontFamily: 'Roboto',
  fontSize: '11pt',
  lineHeight: '1.5',
  paragraphSpacing: '0.5em',
  marginTop: 15,
  marginBottom: 15,
  marginLeft: 15,
  marginRight: 15,
  paperSize: PaperSize.A4,
  orientation: Orientation.Portrait,
};

export const FONT_SIZE_PRESETS = [
  '8pt',
  '9pt',
  '10pt',
  '11pt',
  '12pt',
  '13pt',
  '14pt',
  '15pt',
  '16pt',
] as const;

export const LINE_HEIGHT_PRESETS = [
  '1.0',
  '1.15',
  '1.25',
  '1.5',
  '1.75',
  '2.0',
] as const;

export const PARAGRAPH_SPACING_PRESETS = [
  '0',
  '0.25em',
  '0.5em',
  '0.75em',
  '1em',
] as const;

export const MARGIN_PRESETS = [5, 10, 15, 20, 25] as const;

export const PAPER_SIZE_PRESETS = Object.values(PaperSize);

export const ORIENTATION_PRESETS = Object.values(Orientation);
